import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithQueryParams } from "@utils/http-util";

export type GetAxnRpServicesRequestResponse = {
    axnRPServices: Array<RpServiceConfiguration>;
};

export const getAxnRpServicesRequest = async (
    endpointType: string,
    relyingPartyId: string
): Promise<GenericNetworkResponse<GetAxnRpServicesRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.data.axnrpservice;

    const queryParameters: Array<QueryParameter> = [];

    if (endpointType) {
        queryParameters.push({ parameter: "endpointType", value: endpointType });
    }
    if (relyingPartyId) {
        queryParameters.push({ parameter: "relyingPartyID", value: relyingPartyId });
    }

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};